angular.module("SupportAgent")
.controller(
 'DataAnalyticsController',
 ['$scope','$rootScope',
 function ($scope,$rootScope) {
  $rootScope.menutitle = "Data Analytics";
  $rootScope.loadDataAnalytics = function() {
   if($rootScope.data_analytics_url) {
    var elm=parent.document.getElementById("data_analytics_frame");
    elm.src =$rootScope.data_analytics_url;
   }
   else $rootScope.hide_analytics = true;
  };
  $rootScope.loadDataAnalytics();
 }]);
